export default __webpack_public_path__ + "static/media/img2.15310300.png";